import { Component, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatSlideToggleChange } from "@angular/material/slide-toggle";
import { MatStepper } from "@angular/material/stepper";
import { DomSanitizer } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { AuthService } from "src/app/core/service/auth.service";
import { SubscriptionService } from "src/app/core/service/subscription.service";
import { CategoriaTO } from "src/app/data/schema/Courses/CategoriaTO";
import { Tag } from "src/app/data/schema/Courses/Tag";
import { UsuarioInsertTO } from "src/app/data/schema/User/UsuarioInsertTO";
import { ApiCoursesService } from "src/app/data/service/courses/api-courses.service";
import { DataAnalysisService } from "src/app/data/service/data-analysis/data-analysis.service";
import { ApiUserService } from "src/app/data/service/user/api-user.service";
import { PrivacyPoliceDialogComponent } from "src/app/shared/component/dialogs/privacy-police-dialog/privacy-police-dialog.component";
import { TermsOfUseDialogComponent } from "src/app/shared/component/dialogs/terms-of-use-dialog/terms-of-use-dialog.component";
import { environment } from "src/environments/environment";

@Component({
    selector: "app-registrar-thirdparty",
    templateUrl: "./registrar-thirdparty.component.html",
    styleUrls: ["./registrar-thirdparty.component.scss"]
})
export class RegistrarThirdpartyComponent implements OnInit {
    public user: UsuarioInsertTO = null;

    nascimentoFormGroup: UntypedFormGroup;
    termosUsoFormGroup: UntypedFormGroup;
    politicaPrivacidadeFormGroup: UntypedFormGroup;

    termosUso: string;
    politicaPrivacidade: string;
    isLoading: boolean;
    error: string;
    errorApi: string;
    success: string;
    cadastrado: boolean;
    minDate: Date;
    maxDate: Date;

    tags: Tag[];

    _validPassword: boolean;
    _password: string;

    TermsOfUseClicked = false;
    privacyPolicyClicked = false;

    constructor(
        private translate: TranslateService,
        private formBuilder: UntypedFormBuilder,
        private coursesService: ApiCoursesService,
        private userService: ApiUserService,
        private authService: AuthService,
        private subscriptionService: SubscriptionService,
        private router: Router,
        private domSanitizer: DomSanitizer,
        public _matDialog: MatDialog,
        private dataAnalysisService: DataAnalysisService
    ) {
        this.tags = new Array<Tag>();
        this.isLoading = false;
        this.error = null;
        this.success = null;
        this.cadastrado = false;

        this.minDate = new Date(1900, 1, 1);
        this.maxDate = new Date(Date.now());
    }

    ngOnInit(): void {
        this.user = JSON.parse(sessionStorage.getItem("user-creation-temp"));

        if (this.authService.getCurrentSubscriptionId() == null)
            this.subscriptionService.setCurrentSubscriptionId(environment.default_subscription_id);

        this.coursesService.getCategorias().subscribe((data: CategoriaTO[]) => {
            data.forEach((element) => {
                this.tags.push(new Tag(element));
            });
        });

        this.termosUso = this.subscriptionService.currentSubscription?.settings?.termsOfUseUrl;
        this.politicaPrivacidade = this.subscriptionService.currentSubscription?.settings?.privacyPolicyUrl;

        this.termosUsoFormGroup = this.formBuilder.group({
            aceitoTermos: ["", Validators.required]
        });

        this.politicaPrivacidadeFormGroup = this.formBuilder.group({
            concordoPoliticaPrivacidade: ["", Validators.required]
        });
    }

    selectMainTag(id: string): void {
        const selectedTag = this.tags.filter((tag) => tag.id === id)[0];
        selectedTag.selected = !selectedTag.selected;

        for (let index = 0; index < selectedTag.subCategorias.length; index++) {
            const child = selectedTag.subCategorias[index];
            child.selected = false;
        }
    }

    selectChildrenTag(idParent: string, idChild: string): void {
        const selectedParentTag = this.tags.filter((tag) => tag.id === idParent)[0];

        const selectedTag = selectedParentTag.subCategorias.filter((child) => child.id === idChild)[0];
        selectedTag.selected = !selectedTag.selected;
    }

    getSelectedTags(): Tag[] {
        return this.tags.filter((tag) => tag.selected);
    }

    onChange($event: MatSlideToggleChange, stepper: MatStepper): void {
        if ($event.checked) {
            stepper.next();
        }
    }

    login(): void {
        this.isLoading = true;

        this.authService
            .loginThirdparty(
                this.user.email,
                this.user.googleToken ?? this.user.facebookToken,
                this.authService.getCurrentSubscriptionId()
            )
            .subscribe(
                () => {
                    this.translate
                        .get("REGISTER_THIRDPARTY.DONE.MESSAGES.CREATED")
                        .subscribe((res) => (this.success = res));
                    this.isLoading = false;
                },
                (error) => {
                    this.translate
                        .get("REGISTER_THIRDPARTY.DONE.MESSAGES.CREATE_GENERIC_ERROR")
                        .subscribe((res) => (this.error = res));
                    this.isLoading = false;
                }
            );
    }

    cadastrarUsuario(): void {
        this.isLoading = true;
        this.error = null;
        this.errorApi = null;
        this.success = null;

        const tagsInteressesPrincipais = new Array<string>();

        this.tags
            .filter((tag) => tag.selected)
            .forEach((element) => {
                tagsInteressesPrincipais.push(element.nome);
            });

        const tagsInteressesDetalhes = new Array<string>();

        this.tags
            .filter((tag) => tag.selected)
            .forEach((element) => {
                element.subCategorias
                    .filter((child) => child.selected)
                    .forEach((e) => {
                        tagsInteressesDetalhes.push(e.nome);
                    });
            });

        if (!this._validPassword) return;

        this.userService
            .create(
                this.user.nome,
                this.user.sobrenome,
                this.user.email,
                tagsInteressesPrincipais,
                tagsInteressesDetalhes,
                this._password,
                this.user.googleToken,
                this.user.facebookToken
            )
            .subscribe(
                () => {
                    this.cadastrado = true;
                    this.router.navigate(["/home"]);
                    this.isLoading = false;
                },
                (error) => {
                    this.translate
                        .get("REGISTER_THIRDPARTY.DONE.MESSAGES.AUTH_GENERIC_ERROR")
                        .subscribe((res) => (this.error = res));
                    if (error.status >= 400 && error.status <= 499) this.errorApi = error.error;
                    this.isLoading = false;
                }
            );
    }

    validPassword($event: boolean): void {
        this._validPassword = $event;
    }

    password(event: string): void {
        this._password = event;
    }

    openTermsOfUseDialog(): void {
        this.TermsOfUseClicked = true;
        this._matDialog.open(TermsOfUseDialogComponent);
    }

    openPrivacyPoliceDialog(): void {
        this.privacyPolicyClicked = true;
        this._matDialog.open(PrivacyPoliceDialogComponent);
    }

    getPasswordRegex(): string {
        return this.subscriptionService.currentSubscription?.loginSettings?.defaultLoginOptions?.passwordRegex;
    }

    getPasswordCustomRules(): string {
        return this.subscriptionService.currentSubscription?.loginSettings?.defaultLoginOptions?.passwordCustomRules;
    }
}
